var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 20,
    fill: "#FFA749"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3393_16029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 23.3333C18.3239 23.3333 15.3333 20.3427 15.3333 16.6667C15.3333 12.9907 18.3239 10 21.9999 10C25.6759 10 28.6666 12.9907 28.6666 16.6667C28.6666 20.3427 25.6759 23.3333 21.9999 23.3333ZM21.9999 11.3333C19.0586 11.3333 16.6666 13.7253 16.6666 16.6667C16.6666 19.608 19.0586 22 21.9999 22C24.9412 22 27.3332 19.608 27.3332 16.6667C27.3332 13.7253 24.9412 11.3333 21.9999 11.3333Z",
    fill: "#A75600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1067 38H10.6667C10.2987 38 10 37.7013 10 37.3333V32C10 28.692 12.692 26 16 26H23.68C24.048 26 24.3467 26.2987 24.3467 26.6667C24.3467 27.0347 24.048 27.3333 23.68 27.3333H16C13.4267 27.3333 11.3333 29.4267 11.3333 32V36.6667H22.1067C22.4747 36.6667 22.7733 36.9653 22.7733 37.3333C22.7733 37.7013 22.4747 38 22.1067 38Z",
    fill: "#A75600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 42.0003C28.5547 42.0003 24.6667 38.1123 24.6667 33.3337C24.6667 28.555 28.5547 24.667 33.3334 24.667C38.1121 24.667 42.0001 28.555 42.0001 33.3337C42.0001 38.1123 38.1121 42.0003 33.3334 42.0003ZM33.3334 26.0003C29.2907 26.0003 26.0001 29.291 26.0001 33.3337C26.0001 37.3763 29.2907 40.667 33.3334 40.667C37.3761 40.667 40.6667 37.3763 40.6667 33.3337C40.6667 29.291 37.3761 26.0003 33.3334 26.0003Z",
    fill: "#A75600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0001 36.667C35.8294 36.667 35.6587 36.6017 35.5281 36.4723L32.8614 33.8057C32.7374 33.6803 32.6667 33.511 32.6667 33.3337V29.3337C32.6667 28.9657 32.9654 28.667 33.3334 28.667C33.7014 28.667 34.0001 28.9657 34.0001 29.3337V33.0577L36.4721 35.5297C36.7321 35.7897 36.7321 36.2123 36.4721 36.4723C36.3414 36.6017 36.1707 36.667 36.0001 36.667Z",
    fill: "#A75600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3393_16029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.cd40d6302d813402fd5c414e1c733bb1.svg";
export { ForwardRef as ReactComponent };